import 'rxjs/add/operator/debounceTime';
import {Component, ViewChild} from '@angular/core';
import {DateTime, NavController, NavParams, ViewController} from 'ionic-angular';

import {CONFIG} from '../../../app/config';
import {
    TAction,
    TContatoTipo,
    TProfileTeam,
    TProfileFlag,
    TProfileSexo,
    TReceitaFlag,
    TFiscalRegime,
    TZiptipo, TAddressTipo, TContatoFlag, TLoginTipo,
} from "../../../app/enum";
import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {ProfileService} from "../../../providers/profile-service";
import {ContatoMenuPage} from "../contato-menu/contato-menu";
import {NavRepository} from "../../../repositories/nav-repository";
import {PlasticMenuPage} from "../plastic-menu/plastic-menu";
import {ProfileRepository} from "../../../repositories/profile-repository";
import {NetworkInterface} from "@ionic-native/network-interface";
import {ModalActionPage} from "../modal-action/modal-action";
import {AccountMenuPage} from "../account-menu/account-menu";
import {AddressMenuPage} from "../address-menu/address-menu";
import {MessageService} from "../../../providers/message-service";
import {FacebookService} from "ngx-facebook";
import {ProfileAuthPage} from '../profile-auth/profile-auth';
import {ProfileFotoPage} from "../profile-foto/profile-foto";
import {ProfileShipPage} from '../profile-ship/profile-ship';
import {PrivacyMenuPage} from "../privacy-menu/privacy-menu";
import {ConexaoMenuPage} from "../conexao-menu/conexao-menu";
import {EmissorMenuPage} from '../emissor-menu/emissor-menu';
import {WebstorService} from '../../../providers/webstor-service';
import {ListingMenuPage} from "../listing-menu/listing-menu";
import {MODAL_HTML} from "../../../app/data";

@Component({
    selector: 'page-profile-menu',
    templateUrl: 'profile-menu.html',
    providers: [WebstorService, ProfileService, ProfileRepository]
})
export class ProfileMenuPage {

    @ViewChild(DateTime) iondate: DateTime;
    @ViewChild('inputProfileNome') inputProfileNome: any;

    TProfileTeam: any = TProfileTeam;
    TProfileSexo: any = TProfileSexo;
    TProfileFlag: any = TProfileFlag;
    TReceitaFlag: any = TReceitaFlag;
    TFiscalRegime: any = TFiscalRegime;
    TContatoTipo: any = TContatoTipo;

    config: any;
    logado: any;
    rootile: any;
    copyile: any;

    etapa: number;
    aceite: boolean;
    detail: boolean;
    ipreal: string;
    ipwifi: string;

    facebook: boolean;
    instagram: boolean;

    debouncedTime: number;

    profileNovo: boolean;
    profileSpot: boolean;
    profileSelf: boolean;
    profileTeam: boolean;
    profileZito: boolean;
    profileMini: boolean;
    monitorBool: boolean;
    receitaSpin: boolean;

    profileTemp: string;

    _isentoBool: boolean;

    constructor(public viewCtrl: ViewController, public navCtrl: NavController, public navParams: NavParams,
                public messageService: MessageService, public networkInterface: NetworkInterface,
                private fbWeb: FacebookService, public util: Util,
                public webstorService: WebstorService,
                public logadoService: LogadoService, public profileService: ProfileService, public profileRepository: ProfileRepository,
                public navRepository: NavRepository) {

        this.config = CONFIG;
        this.logado = this.logadoService.getAuth();
        this.rootile = this.navParams.get('rootile');
        this.copyile = this.util.deepCopy(this.rootile);
        this.monitorBool = this.navParams.get('monitorBool');

        this.etapa = 0;
        this.detail = false;
        this.ipreal = '';
        this.ipwifi = '';


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Profile Menu', '/profile-menu');

        //Facebook Init
        if (!this.util.nativeApp()) this.fbWeb.init(CONFIG.iface());

        //Cadastro Novo, Contato Facebook com foto pede para recortar
        if (this.copyile && this.copyile.Contatos && !this.logado) {
            let contato = this.contatoFind(TContatoTipo.coFace);
            if (contato && contato.ContatoFoto) this.pictureEdit(false);
        }

        //Profile Load
        let profileID = this.navParams.get('profileID');
        this.profileLoad(profileID);

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    getTitle() {

        return (this.copyile ? this.copyile.Profile.ProfileShow : '... Carregando ...');

    }

    debounced(back?) {

        if (back) {
            this.debouncedTime = 0;
            this.util.populateObj(this.copyile, this.rootile);
            this.rootile.Profile.EmissorCert64 = '';
            this.copyile.Profile.EmissorCert64 = '';
        }

        if (this.profileNovo)  setTimeout(() => this.inputProfileNome.setFocus(), 2000);
        if (!this.profileNovo) setTimeout(() => this.debouncedTime = 1500, 2000);

    }

    profileCtrl() {

        let empresaNova = ( this.copyile.Profile.ProfileCnpj && !this.copyile.Profile.ProfileID);
        let profileNovo = (!this.copyile.Profile.ProfileCnpj && this.copyile.Profile.ProfileFlag == TProfileFlag.pfGhost);
        
        this.profileNovo = (profileNovo || empresaNova);
        this.profileSelf = !this.profileNovo && this.logado && (this.logado.Profile.ProfileID == this.copyile.Profile.ProfileID);
        this.profileTeam = !this.profileNovo && this.logado && (this.logado.Profile.ProfileTeam >= TProfileTeam.mkManager);
        this.profileZito = !this.profileNovo && this.logado && (this.logado.Profile.ProfileTeam >= TProfileTeam.mkManager && this.logado.Profile.ProfileZito);
        this.profileMini = this.logado && ((!this.profileSelf && !this.profileTeam) || this.copyile.Profile.ProfileCnpj);
        this.profileSpot = this.navParams.get('profileSpot');

    }

    profileNome() {

        this.copyile.Profile.ProfileShow = this.util.nomeCorta(this.copyile.Profile.ProfileNome);

    }

    profileLoad(profileID, show: boolean = true) {

        if (!profileID) {
            this.profileCtrl();
            this.debounced();
            return;
        }

        let loading = this.util.loadingDots();
        if (show) loading.present();

        this.profileService.profile(TAction.acLoad, profileID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    let create = (!this.rootile);

                    if (create) {
                        this.rootile = data;
                        this.copyile = this.util.deepCopy(this.rootile);
                    }

                    if (!create) {
                        this.util.clearObj(this.rootile, [], data);
                        this.util.clearObj(this.copyile, [], data);
                    }


                    this.profileCtrl();
                    this.debounced();
                },
                erro => this.util.alertResult(erro, () => this.dismiss())
            );

    }

    profileSave() {

        //Criando novo registro...
        if (this.profileNovo || this.profileErro()) return;


        //ProfileSave
        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.profile(TAction.acSave, this.copyile.Profile.ProfileID, this.copyile.Profile)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.util.populateObj(this.rootile, this.copyile),
                erro => this.util.alertResult(erro, () => this.debounced(true))
            );

    }

    profileDone() {

        if ( this.profileNovo) this.profileCria();
        if (!this.profileNovo) this.profileSave();

    }

    profileDesk() {

        let loading = this.util.loadingDots();
        loading.present();

        let json = this.copyile;
        let params = '&ProfileRnid=' + json.Profile.ProfileRnid;
        this.util.monitorDesk(this.monitorBool, 'DESK-Profile', 0, params, TAction.acCria, json, 15000)
            .finally(() => loading.dismiss())
            .subscribe(
                root => this.dismiss(this.copyile.Profile),
                erro => this.util.alertResult(erro));

    }

    profileCria() {

        if (!this.profileNovo || this.profileErro()) return;

        //Nascimento Digitado!
        if (this.profileTemp) {
            if (!this.util.validaData(this.profileTemp)) return;
            this.copyile.Profile.ProfileBorn = this.util.strToData(this.profileTemp);
        }

        //MonitorDesk - Cadastra o Profile no Firebird
        if (this.monitorBool) {
            this.profileDesk();
            return;
        }

        // CRIA - Aceite dos Termos
        if (!this.logado && !this.aceite) {
            this.util.alertSimply('Para concluir seu cadastro será necessário concordar com nossos termos.', 'Aceite dos Termos');
            return;
        }

/*
        // OPEN - Facebook para Gravar
        let profileCnpj = this.copyile.Profile.ProfileCnpj;
        if (!this.logado && !this.facebook && !profileCnpj) {

            let onDone = () => {
                this.facebook = true;
                this.profileCria();
            };

            this.contatoMenu(TContatoTipo.coFace, onDone);
            return;

        }


        // OPEN - Instagram para Gravar
        if (!this.logado && !this.instagram && !profileCnpj) {

            let onDone = () => {
                this.instagram = true;
                this.profileCria();
            };

            this.contatoMenu(TContatoTipo.coInst, onDone);
            return;

        }
*/

        // CRIA - profileCria
        let loading = this.util.loadingDots();
        loading.present();

        this.logadoService.started(TAction.acCria, this.copyile)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    let profile = (data.Profiles ? data.Profiles[0] : null);

                    if (profile && profile.ProfileID) {
                        this.rootile.Profile.ProfileID = profile.ProfileID;
                        this.copyile.Profile.ProfileID = profile.ProfileID;
                    }

                    delete this.copyile.Profile.ProfileFace64;
                    delete this.copyile.Profile.ProfileBody64;

                    delete this.rootile.Profile.ProfileFace64;
                    delete this.rootile.Profile.ProfileBody64;

                    //Started Auth
                    let proauth = {
                        ProfileAuth: true,
                        ProfileRnid: this.copyile.Profile.ProfileRnid,
                        ProfileOito: this.copyile.Profile.ProfileOito,
                        Facebook:    null,
                    };

                    if (!this.logado) (window as any).handappMainInstance.profileAuth({Proauth: proauth});


                    //if (!this.profileSpot) 
                    this.dismiss(profile);

                },
                erro => {

                    this.util.alertResult(erro);

                });

    }

    profileSexo() {

        let onConfir = () => {

            let onSave = (sexo) => {
                this.copyile.Profile.ProfileSexo = sexo;
                this.rootile.Profile.ProfileSexo = sexo;
                this.profileSave();
            };

            /** OPEN **/
            let buttons: Array<any> = [];
            buttons.push({text: 'Masculino', handler: () => onSave(TProfileSexo.psMasculino)});
            buttons.push({text: 'Feminino',  handler: () => onSave(TProfileSexo.psFeminino)});
            this.util.sheetOpen(buttons, 'SEXO');

        };

        let bool = (this.copyile.Profile.ProfileCnpj || this.copyile.Profile.ProfileFlag == TProfileFlag.pfGhost);

        let alerta = '<b>Você pode alterar seu SEXO apenas 01 vez.</b><br>' +
            'Informe de acordo com seu documento de identidade.<br><br>' +
            'Para casos <b>INCORRETOS</b>:<br>' +
            '- Poderá ser barrado.<br>' +
            '- Não haverá devolução de <b>pagamento</b>.';
        this.util.alertQuestion('ATENÇÃO!', alerta, 'Eu CONFIRMO', () => onConfir(), bool, true, null);

    }

    profileBorn() {

        this.iondate.open();

    }

    profileFlag(flag) {

        let object = {Profile: {ProfileID: this.copyile.Profile.ProfileID, ProfileFlag: flag}};
        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.profile(TAction.acFlag, this.copyile.Profile.ProfileID, object)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    this.copyile.Profile.ProfileFlag = flag;
                    if (this.profileSelf) this.logout(false);

                },
                erro => {

                    this.util.alertResult(erro);

                });

    }

    profileShip() {

        if (!this.rootile.Profile.ProfileZitu) return;

        /** 7 - MEMBERSHIP **/
        let object = {etapa: 0, rootile: this.rootile, copyile: this.rootile};
        this.util.modalopen(ProfileShipPage, 'quad', true, object).subscribe();

    }

    profileShep() {

        if (!this.rootile.Profile.ProfileZitu) return;

        let onShip = (data) => {
            this.rootile.Profile.ProfileShip = !this.rootile.Profile.ProfileShip;
            this.copyile.Profile.ProfileShip = !this.copyile.Profile.ProfileShip;
        };

        let ship = !this.rootile.Profile.ProfileShip;

        let loading = this.util.loadingDots();
        loading.present();

        this.profileService.profile(TAction.acShip, this.rootile.Profile.ProfileID, null, '&ProfileShip=' + ship)
            .finally(() => loading.dismiss())
            .subscribe(
                data => onShip(data),
                erro => this.util.alertResult(erro)
            );

    }

    profileErro() {

        let copyile = this.copyile;
        let profile = this.copyile.Profile;
        let profileCnpj = this.copyile.Profile.ProfileCnpj;

        //Nascimento Digitado!
        if (this.profileTemp) {
            if (!this.util.validaData(this.profileTemp)) return;
            this.copyile.Profile.ProfileBorn = this.util.strToData(this.profileTemp);
        }
        
        let erro = '';

        //Procria
        let fotoFace = this.util.jsTrim(profile, ['ProfileFace64']);
        let fotoBody = this.util.jsTrim(profile, ['ProfileBody64']);
        let fotoHave = (fotoFace && fotoBody);
        if (!erro && !this.profileMini && !fotoHave && !profileCnpj && !this.logado) erro = 'Sua Foto';

        //Procria | Prosave
        if (!erro && !this.util.jsTrim(profile, ['ProfileNome']))                 erro = 'Seu nome';
        if (!erro && !this.util.jsTrim(profile, ['ProfileName']) &&  profileCnpj) erro = 'Sua razão social';
        if (!erro && !this.util.jsTrim(profile, ['ProfileReid']) &&  profileCnpj && !this._isentoBool) erro = 'Inscrição Estadual';
        if (!erro && !this.util.jsTrim(profile, ['ProfileTrib']) &&  profileCnpj) erro = 'Regime Tributário';
        if (!erro && !this.util.jsTrim(profile, ['ProfileSexo']) && !profileCnpj) erro = 'Seu sexo';
        if (!erro && !this.util.jsTrim(profile, ['ProfileBorn']) && !profileCnpj) erro = 'Sua data de nascimento';
        if (!erro && !this.util.jsCount(copyile, ['Addresss']))                   erro = 'Sua cidade';

        //Field verify
        if (erro) {
            //Field Restore when edit cadastro
            if (!this.profileNovo) this.debounced(true);

            //Mensagem de erro
            this.util.alertSimply(erro, 'Obrigatório Informar');

        }

        return !!erro;

    }

    profileTrib() {

        let onSave = (trib) => {
            this.copyile.Profile.ProfileTrib = trib;
            this.profileSave();
        };

        /** OPEN **/
        let buttons: Array<any> = [];
        buttons.push({text: 'Simples Nacional', handler: () => onSave(TFiscalRegime.frSimples)});
        buttons.push({text: 'Lucro Presumido',  handler: () => onSave(TFiscalRegime.frPresumido)});
        buttons.push({text: 'Lucro Real',       handler: () => onSave(TFiscalRegime.frReal)});
        this.util.sheetOpen(buttons, 'REGIME FISCAL');

    }

    receitaOpen() {

        let profileCnpj = this.copyile.Profile.ProfileCnpj;
        if (profileCnpj)  this.profileRepository.emissorSite(this.copyile.Addresss, 'PJ-FIND');
        if (!profileCnpj) this.profileRepository.emissorSite(this.copyile.Addresss, 'PF-FIND');

    }

    logout(logoutAsk: boolean) {

        this.profileRepository.logout(this.navCtrl, logoutAsk).subscribe();

    }


    emissorMenu() {

        let object = {etapa: 1, rootile: this.rootile, copyile: this.copyile};
        this.util.modalopen(EmissorMenuPage, 'alto', false, object).subscribe();

    }

    networkInfo() {

        this.detail = !this.detail;
        this.util.vibrate(50);

        if (!this.detail) return;

        this.util.realConnection().subscribe(
            data => {this.ipreal = data.query},
            erro => {this.ipreal = 'Sem internet'});

        if (!this.util.nativeApp()) return;

        // IPReal - Native
        // this.networkInterface.getCarrierIPAddress()
        //     .then(data => console.info(`IP: ${data.ip}, Subnet: ${data.subnet}`))
        //     .catch(erro => console.error(`Unable to get IP: ${erro}`));

        this.networkInterface.getWiFiIPAddress()
            .then(data => this.ipwifi = data.ip)
            .catch(erro => this.ipwifi = 'Não conectado');

    }

    contatoText(contatoRede, placeholder) {

        let contato = this.contatoFind(contatoRede);
        return (!contato ? placeholder : contato.ContatoUser);

    }

    contatoFind(contatoRede) {

        return this.copyile.Contatos.find(CO => CO.ContatoRede == contatoRede);

    }

    contatoMenu(contatoRede?, onDone: Function = null) {

        //Contato NEW - Novo
        let contato = this.contatoFind(contatoRede);
        if (!contato && contatoRede) {
            contato = {ContatoRede: contatoRede, ContatoFlag: TContatoFlag.cfNone, ContatoCode: 0, ContatoUser: '', ContatoData: '', ContatoLink: '', ContatoHash: ''};
        }

        let etapa = (contato ? 1 : 0);
        let object = {etapa: etapa, rootile: this.rootile, copyile: this.copyile, contato: contato};
        this.util.modalopen(ContatoMenuPage, 'alto', false, object)
            .finally(() => {
                if (onDone) onDone();
            })
            .subscribe();

    }

    zipcityMenu(event) {

        let onCity = (ziploads) => {

            this.profileRepository.zipcity(ListingMenuPage, ziploads, {ev: event}).subscribe(
                data => {
                    if (!data) return;

                    if (!this.copyile.Addresss || !this.copyile.Addresss[0]) {
                        let zipcity = {ZipcityID: 0, ZipcityZone: '', ZipcityNome: ''};
                        let address = {AddressID: 0, AddressCode: '', AddressVila: '', AddressNome: '', AddressLote: '', AddressTipo: TAddressTipo.adSede, AddressTown: '', AddressRook: '', AddressApto: '', AddressMore: '', Zipcity: zipcity};

                        this.rootile.Addresss = [];
                        this.rootile.Addresss.push(this.util.deepCopy(address));

                        this.copyile.Addresss = [];
                        this.copyile.Addresss.push(this.util.deepCopy(address));
                    }

                    let addroot = this.rootile.Addresss[0];
                    if (!addroot.Zipcity) addroot.Zipcity = {ZipcityID: 0, ZipcityZone: '', ZipcityNome: ''};
                    addroot.Zipcity.ZipcityID   = data.Pkey;
                    addroot.Zipcity.ZipcityZone = data.Zone;
                    addroot.Zipcity.ZipcityNome = data.City;

                    let addcopy = this.copyile.Addresss[0];
                    if (!addcopy.Zipcity) addcopy.Zipcity = {ZipcityID: 0, ZipcityZone: '', ZipcityNome: ''};
                    addcopy.Zipcity.ZipcityID   = data.Pkey;
                    addcopy.Zipcity.ZipcityZone = data.Zone;
                    addcopy.Zipcity.ZipcityNome = data.City;

                });

        };

        let loading = this.util.loadingDots();
        loading.present();

        this.webstorService.zipload(TAction.acLoad, TZiptipo.zpCity)
            .finally(() => loading.dismiss()).subscribe(data => onCity(data.Ziploads));

    }

    addressMenu() {

        let object = {etapa: 1, rootile: this.copyile, indexAD: 0};
        this.util.modalopen(AddressMenuPage, 'alto', false, object).subscribe();

    }

    accountMenu() {

        let object = {etapa: 1, rootile: this.rootile, indexAC: 0};
        this.util.modalopen(AccountMenuPage, 'alto', false, object).subscribe();

    }

    plasticMenu() {

        let object = {etapa: 0, readonly: false, rootile: this.rootile};
        this.util.modalopen(PlasticMenuPage, 'alto', false, object).subscribe();

    }

    conexaoMenu() {

        let object = {etapa: 0, profileID: this.copyile.Profile.ProfileID, hotspotID: 0};
        this.util.modalopen(ConexaoMenuPage, 'alto', false, object).subscribe();

    }

    privacyMenu() {

        /** 4 - PRIVACY **/
        let object = {etapa: 4, rootile: this.rootile, copyile: this.copyile};
        this.util.modalopen(PrivacyMenuPage, 'alto', false, object).subscribe(
            data => {

                //Reload escondido, acabei de alterar a privacidade carrega para vir dados que nao veio
                if (data.privacyEdit) this.profileLoad(this.copyile.Profile.ProfileID, false);

            });

    }

    profileOito() {

        /** 5 - PASSWORD **/
        let object = {etapa: 0, rootile: this.rootile, copyile: this.rootile, loginTipo: TLoginTipo.loRegister, justLogin: true};
        this.util.modalopen(ProfileAuthPage, 'alto', false, object).subscribe();

    }

    pictureEdit(animate) {

        let objectData = {etapa: 1, rootile: this.rootile, copyile: this.copyile};
        this.util.modalopen(ProfileFotoPage, 'alto', false, objectData, {animate: animate}).subscribe();

    }

    profileLeao() {

        if (!this.logado.Profile.ProfileTeam) return;

        let onDone = (data) => {
            this.copyile.Profile.ReceitaFlag = data.Profiles[0].ReceitaFlag;
            this.copyile.Profile.ReceitaCode = data.Profiles[0].ReceitaCode;
            this.util.populateObj(this.rootile, this.copyile);
        };

        this.receitaSpin = true;

        //#BORN - Adicionado o Rnid no profileFind repository!
        let params = '&ProfileRnid=' + this.copyile.Profile.ProfileRnid + '&ProfileBorn=' + this.copyile.Profile.ProfileBorn;
        this.profileService.profile(TAction.acBorn, this.copyile.Profile.ProfileID, null, params)
            .finally(() => this.receitaSpin = false)
            .subscribe(
                data => onDone(data),
                erro => this.util.alertResult(erro)
            );

    }

    spotusTerm(keyname) {

        //HTML Simple
        let objectData = {modalfull: true, modalinfo: this.config.modalinfo(this.util, 'animehtml')};
        objectData.modalinfo.header = MODAL_HTML[keyname].titulo;
        objectData.modalinfo.titulo = MODAL_HTML[keyname].resumo;
        objectData.modalinfo.resumo = MODAL_HTML[keyname].html;

        this.util.modalopen(ModalActionPage, 'wide', true, objectData).subscribe();

    }



    dismiss(data?) {

        if (this.copyile) {
            this.copyile.Profile.ProfileFace64 = '';
            this.copyile.Profile.ProfileBody64 = '';
        }

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

        if (this.viewCtrl.isOverlay) {
            this.viewCtrl.dismiss(data);
            return;
        }

        this.navCtrl.pop();

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/profile-menu/profile-menu.ts